module.exports = __webpack_public_path__ + "img/page.738bb598.png";